import React, { Component } from 'react';
import { connect } from 'react-redux';
import  OfficeSetupMember  from '../../../components/UI/Member/OfficeSetupMember';
import { Label, Input, Button,Alert , Popover, PopoverHeader, PopoverBody,Breadcrumb, BreadcrumbItem } from 'reactstrap';
import Tooltip from '../../../components/UI/TooltipIcon/TooptipIcon';
import ErrorMessage from '../../../components/Message/ErrorMessage/ErrorMessage';
import { deepClone } from '../../../utils/copyObject';
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import filter from 'lodash/filter';
import axios from '../../../axios';
import {roleOptions} from '../../../utils/constants';
import * as url from '../../../utils/url';
import addIcon from '../../../assets/plus.svg';
import { validateEmail } from '../../../utils/validations';
// import Loading from '../../../hoc/Loading/LoadingWithError';
import Loading from '../../../hoc/Loading/Loading';

import './InviteOfficeMates.css';

class InviteOfficeMates extends Component {

  constructor(props) {
    super(props);
    this.state = {
      shownMembersCount: 3,
      members: [],
      error: false,
      errorMessage: '',
      toggleRoleOpen:false,
      success:false,
      successMessage:'',
      notifyWarning: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleAddMember = () => {
    const { shownMembersCount } = this.state;
    this.setState({ shownMembersCount: shownMembersCount + 1 });
  }

  handleMemberDetailsAdded = (id, data) => {
    const { name, value } = data;
    const { members } = this.state;
    let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g
    let specialCount=0
    // console.log(members)
    console.log(name, value, members)
    let index = findIndex(members, { id: id });
    if (index > -1) {
      // console.log(members[index][name])
      members[index][name] = value;
    } else {
      members.push({ id: id, [name]: value, role: data.name === 'role' ? data.value : 'Member' });
    }
    this.setState({ members: members });
  }

  populateAddMemberInputs = () => {
    let inputs = [];
    const { members } = this.state;
    console.log(this.props)
    for (let i = 0; i < this.state.shownMembersCount; i++) {
      inputs.push(<OfficeSetupMember memberData={find(members, { id: i })} id={i} key={i}
        onInputChange={this.handleMemberDetailsAdded} {...this.props}/>);
    }
    return inputs;
  }

  showErrorMsg=(error,message)=>{
    console.log('inside function showmsg')
    if (error && message) {
      let errorString = error.join(", ");

      if (message.includes("Invalid email Id") && message !== undefined) {
        console.log('msg')
        // this.setState({ error: true, errorMessage: errorString.replace(/,/g, ', ') + ' ' + 'Please enter a valid email.' });
        this.setState({ error: true, errorMessage:'Please enter a valid email.' });

      } else {
        console.log('err----')
        if(error.length===1){
          this.setState({ error: true, errorMessage: errorString + ' ' + ' has been invited before and can not be re-invited.' });
        } else {
          console.log('miltipls---')
          this.setState({ error: true, errorMessage: errorString + ' ' + ' have been invited before and can not be re-invited' });
        }
      }
    } else {
      this.setState({ error: true, errorMessage: 'Failed to add invite members.' });
    }
  }

  handleSendInvite = (notify = true) => {
    let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g
    // let specialCount=0
    this.setState({success:false,error:false})
    let members = Array.from(this.state.members);
    members = deepClone(members);
    let membersFiltered = members.filter( el => (el.email && el.email != "") || (el.mobileNumber && el.mobileNumber != ""))
    console.log(membersFiltered)
    const invalidMembers = filter(membersFiltered, (member) => {
      if ((!member.email && !member.mobileNumber) || specialChar.test(member.firstName) || specialChar.test(member.lastName)) {
        if (member.role === 'Admin') {
          return true;
        }
        return member
      }
      return false;
    })
    if (membersFiltered.length === 0) {
      this.setState({ error: true, errorMessage: 'Please enter details to invite members. An email or mobile number is required.' });
      return;
    }
    console.log(invalidMembers)

    if (invalidMembers.length > 0) {
      window.scroll(0, 0);
      this.setState({
        error: true,
        errorMessage: 'Please enter a valid email or mobile number, and first/last name without any special characters.'
      });
      return;
    } else {
      this.setState({
        error: false
      })
    }

    // Normalize and validate phone numbers
    var invalidPhone = membersFiltered.filter(function(member) {
      if (member.mobileNumber && member.mobileNumber !== '') {
        var cleaned = member.mobileNumber.replace(/[\s\-\(\)]/g, '');
        // Auto-prepend + if 11 digits starting with 1 (e.g. 13104398686 → +13104398686)
        if (/^\d{11}$/.test(cleaned) && cleaned.charAt(0) === '1') {
          cleaned = '+' + cleaned;
          member.mobileNumber = cleaned;
        }
        if (!/^\+\d+$/.test(cleaned)) return true;
        if (cleaned.length !== 12) return true;
      }
      return false;
    });
    if (invalidPhone.length > 0) {
      this.setState({ error: true, errorMessage: 'The number does not seem to be correct. Please check the number and re-enter.' });
      return;
    }

    // Check if any members have no email and notify is requested
    var phoneOnlyMembers = membersFiltered.filter(function(member) {
      return (!member.email || member.email === '') && member.mobileNumber && member.mobileNumber !== '';
    });
    if (notify && phoneOnlyMembers.length > 0) {
      this.setState({ notifyWarning: true });
    }

    // Generate dummy email for phone-only members (same pattern as CSV upload)
    membersFiltered.forEach((member) => {
      if ((!member.email || member.email === "") && member.mobileNumber && member.mobileNumber !== "") {
        member.email = `temp_${Date.now()}_${Math.random().toString().slice(2, 8)}@exampleemail.com`;
        member.isDummyEmail = true;
      }
    });
    // let missingDetails = membersFiltered.filter(member => {
    //   console.log(member)
    //   if(member.firstName=="" && member.lastName=="" && member.email!=""){
    //     return member
    //   } 
    // });
    // if (missingDetails.length === 0) {
    //   this.setState({ error: true, errorMessage: 'Please enter emails to invite members.' });
    //   return;
    // }
    

    const payload = { data: membersFiltered, notify };
    axios.post(url.addMembers, payload).then((response) => {
      console.log(response)
      if (response && response.length!=0 && response!==undefined && response.data && response.data !== undefined) {
        let {data} = response.data
        let stateUpdate= {
          success:true,
          successMessage: data.successRes.length + (data.successRes.length > 1 ? ' users' : ' user') + ' successfully invited.',
          members:[]
        }

        let error = data && data.errorRes && data.errorRes.length>0 ?true:false
       
        if(error){
          stateUpdate.error=error
          stateUpdate.errorMessage = data.errorRes.length>1? 
                                data.errorRes.join(', ') + 'have been invited before and can not be re-invited':
                                data.errorRes + ' has been invited before and can not be re-invited.'
        }
        console.log(stateUpdate)
        this.setState( stateUpdate )
      }
    }).catch( err => {
   
      let{error, message}= err && err.response && err.response.data && err.response.data.errors
      ? err.response.data.errors
      : { error: null, message: null };
        // this.showErrorMsg(error, message)
        console.log(error, message)
        if (error && message) {
          // Handle duplicate key error (mobile number already exists)
          if (message && message.includes && message.includes('duplicate key error') && message.includes('mobileNumber')) {
            this.setState({ error: true, errorMessage: 'This mobile number has been invited before and can not be re-invited.' });
            return;
          }
          let errorString = Array.isArray(error) ? error.join(", ") : (typeof error === 'string' ? error : 'A user');

          if (message.includes("Invalid email Id") && message !== undefined) {
            console.log('msg')
            // this.setState({ error: true, errorMessage: errorString.replace(/,/g, ', ') + ' ' + 'Please enter a valid email.' });
            this.setState({ error: true, errorMessage:'Please enter a valid email.' });
    
          } else {
            console.log('err----')
            if(error.length===1){
              this.setState({ error: true, errorMessage: errorString + ' ' + ' has been invited before and can not be re-invited.' });
            } else {
              console.log('miltipls---')
              this.setState({ error: true, errorMessage: errorString + ' ' + ' have been invited before and can not be re-invited.' });
            }
          }
        } else {
          this.setState({ error: true, errorMessage: 'Failed to add invite members.' });
        }
     
      
      // rcfro2+104@gmail.com
     
    });
  }

  navigateToOfficeMates = () => {
    this.props.history.push('/home/users');
  }

  toggleRoleInfo = () => {
    this.setState({ toggleRoleOpen: !this.state.toggleRoleOpen });
  }


  // shouldComponentUpdate(nextProps, nextState) {
  //   if (this.props.error !== nextProps.error) {
  //     console.log(this.props)
  //     // this.showErrorMsg(this.props.error.response)
  //   }
  //   return false;
  // }

  render() {
    let { error, errorMessage, successMessage, success} = this.state;
    let {user}=this.props
    let{role}=user
    console.log(this.state)
      

    return (
      <div className="inviteUserContainer">
        <div>
          <Breadcrumb>
            <BreadcrumbItem>
              <a className="officemates-link" onClick={this.navigateToOfficeMates}>
                Users
              </a>
            </BreadcrumbItem>
            <BreadcrumbItem active>
              <span className="invite-officemate-name-breadcrumb">
              Invite Others to this Workspace 
              </span>
            </BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div className="invite-officemates-title">Invite Others to this Workspace </div>
        <div className="invite-officemate-hrLine mt10"></div>

         {/* To invite others, please provide their login information below and select a role for each one, as a user or an admin. You can always change role or remove them as needed. */}
        {/* <div className="text-primary-color setup-content mt20">
              <div className="text-primary-color setup-content mb40">
              Invite your officemates to the platform by inputting their login information below and assigning them
              roles.{role==='Member'? <span> As a Member, you can invite other Admins, Users, and other Members. </span>:
              role==='User'? <span> As a User, you can invite Admins, others Users, Members. </span>: <span> As an Admin, you can invite other Admins, Users or Members. </span>}
              <span> For more info on roles and privileges, click here 
                <span id="toggleRoleOpen-popover" className="mlRBACInfo" onClick={()=>this.toggleRoleInfo()}><Tooltip /></span>.
                  <Popover placement="right" isOpen={this.state.toggleRoleOpen} target="toggleRoleOpen-popover" toggle={()=>this.toggleRoleInfo()}>
                    <PopoverHeader className="popover-header-tooltip">
                      Roles and Privileges
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      {roleOptions.map( (e, idx)=>{
                        return <p key={idx}>{e.label}: {e.definition} </p>
                      })}
                      
                    </PopoverBody>
                  </Popover> 
                </span>
            </div> 
        </div> */}
        <div className='py-2'></div>
        { success ?
          <Alert color="success">
            {successMessage}
          </Alert>
        :
        null
        }
        { this.state.notifyWarning ?
          <Alert color="info" toggle={() => this.setState({ notifyWarning: false })}>
            Notifications are only sent to users who have an Email.
          </Alert>
        :
        null
        }
        {
          error ?

          <div className="mt20"><ErrorMessage message={errorMessage} /></div>
          :

          null
        }
        <div className="row mt40">
          <div className="col">
            <Label for="role" className="field-lable" style={{ float: 'left', fontSize: '13px' }}>Role</Label>
          </div>
          <div className="col">
            <Label for="email" className="field-lable" style={{ float: 'left', fontSize: '13px' }}>Email</Label>
          </div>
          <div className="col">
            <Label for="mobileNumber" className="field-lable" style={{ float: 'left', fontSize: '13px' }}>Mobile Number</Label>
          </div>
          <div className="col">
            <Label for="firstName" className="field-lable" style={{ float: 'left', fontSize: '13px' }}>First Name
                <span className="optional-text" style={{ fontSize: '12px', lineHeight: '22px' }}> (Optional)</span></Label>
          </div>
          <div className="col">
            <Label for="lastName" className="field-lable" style={{ float: 'left', fontSize: '13px' }}>Last Name
                <span className="optional-text" style={{ fontSize: '12px', lineHeight: '22px' }}> (Optional)</span></Label>
          </div>
        </div>
        {
          this.populateAddMemberInputs()
        }
        <div className="row" style={{ marginTop: 20 }}>
          <div className="col cursor-pointer" onClick={this.handleAddMember}>
            <img style={{ marginRight: '10px' }} src={addIcon} height="25px" width="25px" />
            <a className="add-officemate-link">Add another</a>
          </div>
        </div>
        <div className="row mb10">
          <div className="col d-flex justify-content-end" style={{ gap: '10px' }}>
            <Button color="secondary" outline
              onClick={() => this.handleSendInvite(false)}
              className="btn-continue">
              Do Not Notify
            </Button>
            <Button color="primary"
              onClick={() => this.handleSendInvite(true)}
              className="btn-continue">
              Notify
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
	return {
    toolDetails : state.toolkit.toolDetails,
    user: state.user.profile
	}
}


export default connect(mapStateToProps)(Loading(InviteOfficeMates, axios));
